import { ComponentProps } from "react";

const ExclamationIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_882_4148)">
        <path
          d="M9 0C7.21997 0 5.47991 0.527841 3.99987 1.51677C2.51983 2.50571 1.36628 3.91131 0.685088 5.55585C0.00389957 7.20038 -0.17433 9.00998 0.172937 10.7558C0.520204 12.5016 1.37737 14.1053 2.63604 15.364C3.89472 16.6226 5.49836 17.4798 7.24419 17.8271C8.99002 18.1743 10.7996 17.9961 12.4442 17.3149C14.0887 16.6337 15.4943 15.4802 16.4832 14.0001C17.4722 12.5201 18 10.78 18 9C17.9974 6.61384 17.0484 4.32616 15.3611 2.63889C13.6738 0.951621 11.3862 0.00258081 9 0V0ZM9 16.5C7.51664 16.5 6.0666 16.0601 4.83323 15.236C3.59986 14.4119 2.63856 13.2406 2.07091 11.8701C1.50325 10.4997 1.35473 8.99168 1.64411 7.53682C1.9335 6.08197 2.64781 4.74559 3.6967 3.6967C4.7456 2.64781 6.08197 1.9335 7.53683 1.64411C8.99168 1.35472 10.4997 1.50325 11.8701 2.0709C13.2406 2.63856 14.4119 3.59985 15.236 4.83322C16.0601 6.06659 16.5 7.51664 16.5 9C16.4978 10.9885 15.7069 12.8948 14.3009 14.3009C12.8948 15.7069 10.9885 16.4978 9 16.5Z"
          fill="currentColor"
        />
        <path
          d="M9 3.75012C8.80109 3.75012 8.61032 3.82914 8.46967 3.96979C8.32902 4.11044 8.25 4.30121 8.25 4.50012V10.5001C8.25 10.699 8.32902 10.8898 8.46967 11.0305C8.61032 11.1711 8.80109 11.2501 9 11.2501C9.19892 11.2501 9.38968 11.1711 9.53034 11.0305C9.67099 10.8898 9.75001 10.699 9.75001 10.5001V4.50012C9.75001 4.30121 9.67099 4.11044 9.53034 3.96979C9.38968 3.82914 9.19892 3.75012 9 3.75012Z"
          fill="currentColor"
        />
        <path
          d="M9.75001 13.5001C9.75001 13.0859 9.41422 12.7501 9 12.7501C8.58579 12.7501 8.25 13.0859 8.25 13.5001C8.25 13.9143 8.58579 14.2501 9 14.2501C9.41422 14.2501 9.75001 13.9143 9.75001 13.5001Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_882_4148">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ExclamationIcon;
